import { ChangeFlightEligibilityModalContent } from "../ChangeFlightEligibilityModal";
import type { UseFlightCancelPolicyProps } from "@/modules/flights-postbooking/hooks";

export interface FlightReservationExchangeProps
  extends Pick<UseFlightCancelPolicyProps, "itinerary"> {
  /** Whether exchange functionality is enabled. When false, shows contact support message instead of policy details. */
  isEnabled?: boolean;
  /** Callback to navigate back to trip details */
  onBack?: () => void;
}

export const FlightReservationExchange = ({
  itinerary,
  isEnabled = false,
  onBack,
}: FlightReservationExchangeProps) => {
  return (
    <ChangeFlightEligibilityModalContent
      itinerary={itinerary}
      isEnabled={isEnabled}
      onBack={onBack}
    />
  );
};
